import { useAppSelector } from '../../hooks';

export const useBookInfo = () => {
  return useAppSelector(state => {
    const { id, pagesCount, title } = state.book;
    return { id, pagesCount, title };
  });
};
